<template>
  <div
    :class="[
      'flex items-center justify-center justify-between border rounded-[4px] p-1',
      containerClass,
      { 'w-full': fullWidth, 'w-auto': !fullWidth },
    ]"
  >
    <button
      :disabled="quantity <= min"
      class="text-gray-500 pl-2 disabled:opacity-50 disabled:cursor-not-allowed"
      @click.stop.prevent="decrement"
    >
      -
    </button>

    <div class="flex flex-row items-center gap-1">
      <UInput
        v-model="quantity"
        variant="none"
        :ui="{
          root: 'w-auto',
          base: 'text-gray-700 text-center font-medium p-0',
        }"
        @update:model-value="emitUpdate"
        @click.stop.prevent
      />
    </div>

    <button
      :disabled="quantity >= max"
      class="text-gray-500 pr-2 disabled:opacity-50 disabled:cursor-not-allowed"
      @click.stop.prevent="increment"
    >
      +
    </button>
  </div>
</template>

<script setup lang="ts">
  interface DjQuantityProps {
    modelValue: number;
    min?: number;
    max?: number;
    step?: number;
    fullWidth?: boolean;
    containerClass?: string;
  }
  const props = withDefaults(defineProps<DjQuantityProps>(), {
    modelValue: 1,
    min: 0,
    max: 100,
    step: 1,
    fullWidth: false,
    containerClass: '',
  });

  const quantity = ref(props.modelValue);

  const increment = () => {
    if (quantity.value < props.max) {
      quantity.value += props.step;
      emitUpdate();
    }
  };

  const decrement = () => {
    if (quantity.value > props.min) {
      quantity.value -= props.step;
      emitUpdate();
    }
  };

  const emit = defineEmits<{
    'update:modelValue': [quantity: number];
  }>();

  function emitUpdate() {
    emit('update:modelValue', quantity.value);
  }

  watch(quantity, (newValue) => {
    if (newValue > props.max) {
      quantity.value = props.max;
      emitUpdate();
    }
  });
</script>
